import React from 'react';
import { CardNetwork } from './CardNetwork.js';

// Identification artwork only, not checkout buttons or a live acceptance claim.
export const PaymentBrandRow: React.FC = () => (
  <div
    className="payment-brand-row"
    role="group"
    aria-label="Card networks and mobile wallets on eligible cards"
  >
    <span className="payment-brand-tile">
      <CardNetwork network="visa" />
    </span>
    <span className="payment-brand-tile">
      <CardNetwork network="mastercard" />
    </span>
    <span className="payment-brand-tile">
      <img src="/brands/apple-pay-borderless.svg" alt="Apple Pay" width="125" height="55" />
    </span>
    <span className="payment-brand-tile">
      <img
        className="google-pay-official"
        src="/brands/google-pay-borderless.svg"
        alt="Google Pay"
        width="535"
        height="215"
      />
    </span>
  </div>
);
